<template>
  <div id="carList1">
    <ly-search v-if="!hideSearch" @search="reach" size="small" v-model="keyword" placeholder="请选择">
    </ly-search>
    <div id="ulWrap" class="gundongtiao">
      <ul>
        <li v-for="(item, index) in carList" :key="index" @click="clickLi(item)">
          <img class="dasimg" :src="axios.platConfig.fileUri +
            'mapicon/' +
            item.carTypeIcon +
            '/big.png'
            " />
          {{ item.carNo }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["isMore", "filter", "filterGroup","hideSearch"],
  data() {
    return {
      keyword: "",
      carList: [],

    };
  },
  methods: {
    getCarList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/car/list",
        data: {
          keyword: this.keyword,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        var filter = this.filter;
        data = data.filter(function (item) {
          return filter ? item.labelList.includes(filter) : item;
        });
        //console.log(data);
        this.carList = data;
        //console.log('cheliangshuju', data);
      });
    },
    clickLi(row) {
      this.$emit("car", row);
    },
    reach(v) {
      this.keyword = v;
      this.getCarList();

    },
  },
};
</script>
<style>
#carList1 li:hover {
  background: #ebf8fc;
  cursor: pointer;
}

#carList1 li {
  padding: 2px 4px;
}

#carList1 {
  height: calc(100% - 0px);
  padding: 10px 0;
}

#carList1 #ulWrap {
  height: calc(100% - 30px);
  overflow: auto;
}

#carList1 li .dasimg {
  vertical-align: middle;
  height: 18px;
  margin-right: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/carList.vue